define("shared/utils/media-adjustments/build-media-spec-params", ["exports", "@ember/utils", "shared/utils/crop-array"], function (_exports, _utils, _cropArray) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.buildMediaSpecParams = buildMediaSpecParams;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils",0,"shared/utils/crop-array"eaimeta@70e063a35619d71f
  function imageFormatFromKey(imageKey) {
    if (!imageKey) {
      return undefined;
    }
    const extension = imageKey.split('.').pop()?.toLowerCase();
    if (!extension) {
      return undefined;
    }
    if (extension === 'jpeg') {
      return 'jpg';
    }
    return extension;
  }
  function buildMediaSpecParams(postMediaItem, post) {
    const mediaItemId = postMediaItem.belongsTo('mediaItem').id();
    if (!mediaItemId) {
      return null;
    }
    const mediaItem = postMediaItem.store.peekRecord('media-item', mediaItemId);
    const socialProfileId = post.belongsTo('socialProfile').id();
    const socialProfile = socialProfileId ? post.store.peekRecord('social-profile', socialProfileId) : null;
    const width = postMediaItem.croppedWidth ?? postMediaItem.width ?? mediaItem?.publishingWidth ?? mediaItem?.width;
    const height = postMediaItem.croppedHeight ?? postMediaItem.height ?? mediaItem?.publishingHeight ?? mediaItem?.height;
    const fileSize = mediaItem?.publishingFileSize ?? mediaItem?.fileSize;
    const {
      cropArray
    } = postMediaItem;
    const imageKey = postMediaItem.imageKey ?? mediaItem?.imageKey;
    const params = {
      media_item_id: mediaItemId,
      auto_publish: post.autoPublish
    };
    if (!(0, _utils.isNone)(width)) {
      params.width = width;
    }
    if (!(0, _utils.isNone)(height)) {
      params.height = height;
    }
    if (!(0, _utils.isNone)(fileSize)) {
      params.file_size = fileSize;
    }
    if (cropArray?.length) {
      params.crop_array = (0, _cropArray.canonicalizeCropArray)(cropArray);
    }
    const imageFormat = imageFormatFromKey(imageKey);
    if (imageFormat) {
      params.image_format = imageFormat;
    }
    const {
      profileType
    } = socialProfile ?? {};
    if (profileType) {
      params.platform = profileType;
    }
    if (socialProfileId) {
      params.social_profile_id = socialProfileId;
    }
    return params;
  }
});